<!-- 首页头部信息 -->
<template>
  <div class="topbar-box">
    <div class="topbar-container" :class="{ scrolled: scorllColor }">
      <!-- Logo 左侧 -->
      <div class="left">
        <router-link to="/">
          <img :src="getsrc" alt="Logo" class="logo" />
        </router-link>
      </div>

      <!-- 导航右侧 -->
      <div class="right">
        <ul class="nav-list" ref="topMenu">
          <!-- 首页 -->
          <li class="nav-item" @click.prevent="removeMoving()">
            <router-link to="/homePage" :class="{ active: isActive }"
              >首页</router-link
            >
          </li>
          <!-- 产品介绍 -->
          <li
            class="nav-item has-dropdown"
            @mouseenter="isPc && handleDropdownHover('product1')"
            @mouseleave="isPc && handleDropdownLeave('product1')"
            @click="toggleDropdown('product1')"
          >
            <span :class="{ active: isActive1 }">产品介绍</span>
            <ul class="dropdown-menu" v-show="dropdownVisible.product1">
              <li
                :class="isactiveLine('/tablet5G') ? 'activeLLine' : ''"
                @click.stop="handclick1('/tablet5G')"
              >
                讯天行业5G平板
              </li>
              <li
                :class="isactiveLine('/wisdomTeaching') ? 'activeLLine' : ''"
                @click.stop="handclick1('/wisdomTeaching')"
              >
                讯天全场景智教平台
              </li>
              <div class="listMask"></div>
              <li
                :class="isactiveLine('/videoRecorder') ? 'activeLLine' : ''"
                @click.stop="handclick1('/videoRecorder')"
              >
                讯天音视频记录仪
              </li>
            </ul>
          </li>
          <!-- 解决方案 -->
          <li
            class="nav-item has-dropdown"
            @mouseenter="handleDropdownHover('product2')"
            @mouseleave="handleDropdownLeave('product2')"
            @click="toggleDropdown('product2')"
          >
            <span :class="{ active: isActive2 }">解决方案</span>
            <ul class="dropdown-menu" v-show="dropdownVisible.product2">
              <li
                :class="isactiveLine('/educationBenefits') ? 'activeLLine' : ''"
                @click.stop="handclick2('/educationBenefits')"
              >
                教鸿解决方案
              </li>
              <div class="listMask"></div>
            </ul>
          </li>
          <!-- 其他菜单项 -->
          <li class="nav-item" @click.prevent="removeMoving()">
            <router-link
              to="/ecologicalCooperation"
              :class="{ active: isActive3 }"
              >生态合作</router-link
            >
          </li>
          <li class="nav-item" @click.prevent="removeMoving()">
            <router-link to="/newsCenter" :class="{ active: isActive4 }"
              >新闻中心</router-link
            >
          </li>
        </ul>
        <!-- 移动端菜单按钮（可选） -->
        <button class="menu-toggle" @click.stop="toggleMobileMenu">☰</button>
        <div
          class="mask"
          v-if="mobileMenuOpen"
          :class="{ 'mobile-open': mobileMenuOpen }"
          @click.stop="toggleMobileMenu"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/projectLogo.png';
import router from '@/router';

export default {
  name: 'TopBar',
  props: {
    color: {
      type: String,
      default: '#fff',
    },
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logo,
      getcolor: this.color,
      getsrc: this.src,
      mobileMenuOpen: false,
      dropdownVisible: {
        product1: false,
        product2: false,
      },
      leaveTimeout: null,
      dropDown: false,
    };
  },
  watch: {
    // isActive(newVal) {
    //   if (newVal === true && !this.isPc) {
    //     console.log(11111111111);
    //     this.toggleDropdown('product1');
    //   }
    // },
    // isActive2(newVal) {
    //   if (newVal === true && !this.isPc) {
    //     this.toggleDropdown('product2');
    //   }
    // },
  },
  computed: {
    isPc() {
      return window.innerWidth > 830;
    },
    isActive() {
      return ['/homePage'].includes(this.$route.path);
    },
    isActive1() {
      return ['/tablet5G', '/wisdomTeaching', '/videoRecorder'].includes(
        this.$route.path
      );
    },

    isActive2() {
      return ['/educationBenefits'].includes(this.$route.path);
    },
    isActive3() {
      return ['/ecologicalCooperation'].includes(this.$route.path);
    },
    isActive4() {
      return ['/newsCenter'].includes(this.$route.path);
    },
    scorllColor() {
      if (this.$store.state.scorllTop > 300) {
        this.getcolor = '#000';
        this.getsrc = this.logo;
        return true;
      } else {
        this.getcolor = this.color;
        this.getsrc = this.src;
        return false;
      }
    },
  },
  methods: {
    isactiveLine(name) {
      if (this.$route.path === name) {
        return true;
      } else {
        return false;
      }
    },
    handclick1(path) {
      if (this.$route.path === path) return;
      router.push(path);
      this.dropdownVisible.product1 = false;
      // 新增：关闭移动端菜单
      this.removeMoving();
    },
    handclick2(path) {
      if (this.$route.path === path) return;
      router.push(path);
      this.dropdownVisible.product2 = false;
      // 新增：关闭移动端菜单
      this.removeMoving();
    },
    removeMoving() {
      this.mobileMenuOpen = false;
      this.$refs.topMenu.classList.remove('mobile-open');
      Object.keys(this.dropdownVisible).forEach((key) => {
        this.$set(this.dropdownVisible, key, false);
      });
    },
    toggleDropdown(productKey) {
      if (!this.isPc) {
        const currentState = this.dropdownVisible[productKey];
        // 先关闭所有菜单
        Object.keys(this.dropdownVisible).forEach((key) => {
          this.$set(this.dropdownVisible, key, false);
        });
        this.$set(this.dropdownVisible, productKey, !currentState);
      }
    },
    handleDropdownHover(productKey) {
      if (this.isPc) {
        clearTimeout(this.leaveTimeout);
        this.dropdownVisible[productKey] = true;
      }
    },
    handleDropdownLeave(productKey) {
      if (this.isPc) {
        this.leaveTimeout = setTimeout(() => {
          this.dropdownVisible[productKey] = false;
        }, 200);
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.$refs.topMenu.classList.toggle('mobile-open', this.mobileMenuOpen);
      if (this.isActive1 && !this.isPc) {
        this.toggleDropdown('product1');
      }
      if (this.isActive2 && !this.isPc) {
        this.toggleDropdown('product2');
      }
    },
  },
};
</script>

<style scoped>
.topbar-box {
  width: 100%;
}

.topbar-container {
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.topbar-container.scrolled {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.left .logo {
  width: 166px;
  height: 38px;
}

.right {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  margin-right: 50px;
  cursor: pointer;
}

.nav-item:last-child {
  margin-right: 0;
}

.nav-item a,
.nav-item span {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;
}

.nav-item .active {
  font-family: 'Bold', sans-serif;
  color: #0062ff;
}
.nav-item .activeLLine {
  /* border-bottom: 2px solid #0062ff; */
  background-color: #e2eaff;
}
/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 160px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
  z-index: 999;
}

.dropdown-menu li {
  padding: 12px 20px;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.dropdown-menu li:hover {
  background-color: rgba(13, 83, 255, 0.12);
}

.nav-item:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}
/* 移动端样式 */
.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
}

/* 右侧滑出菜单样式 */
@media (max-width: 830px) {
  .nav-item {
    position: relative;
    margin-right: 0;
    padding: 10px 0;
    cursor: pointer;
  }
  .nav-item:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
  }
  .dropdown-menu {
    position: static;
    margin-left: 80px;
    background-color: #f9f9f9;
    /* display: none; */
    visibility: visible !important;
    z-index: 9999;
    width: 100%;
    box-shadow: none;
    margin-top: 10px;
  }
  .dropdown-menu li {
    padding: 10px 20px;
  }
  .menu-toggle {
    display: block;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #000;
  }
  .nav-list {
    position: fixed;
    top: 0;
    right: -200px;
    width: 200px;
    height: 100%;
    background-color: #fff;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
    flex-direction: column;
    /* padding: 60px 0 0 0; */
    transition: right 0.3s ease;
    z-index: 9999;
    padding-left: 20px;
  }

  .nav-list.mobile-open {
    right: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
    display: block;
  }
}
</style>
